/**
 * Sport folder definitions — maps to the folders in the Graphics Library
 *
 * Template IDs will be populated as NewBlue delivers SVG assets.
 * Currently only Baseball and Softball have box score templates.
 */
import type { SportFolder } from '@graphicsim/shared-types';

export const sportFolders: SportFolder[] = [
  { id: 'baseball',    name: 'Baseball',    templateIds: ['bb-boxscore'] },
  { id: 'basketball',  name: 'Basketball',  templateIds: [] },
  { id: 'bugs',        name: 'Bugs',        templateIds: [] },
  { id: 'football',    name: 'Football',    templateIds: ['fb-bottom-scoreboard', 'fb-halftime-stats', 'fb-lower-third', 'fb-matchup'] },
  { id: 'general',     name: 'General',     templateIds: [] },
  { id: 'hockey',      name: 'Hockey',      templateIds: [] },
  { id: 'pickleball',  name: 'Pickleball',  templateIds: [] },
  { id: 'soccer',      name: 'Soccer',      templateIds: [] },
  { id: 'softball',    name: 'Softball',    templateIds: ['sb-boxscore'] },
  { id: 'volleyball',  name: 'Volleyball',  templateIds: [] },
  { id: 'wrestling',   name: 'Wrestling',   templateIds: [] },
];
